<template>
  <div>
    <template v-if="maxCharacter">
      {{ excerpt }}
    </template>
    <template v-else>
      <template
        v-if="
          field &&
          field.resourceExcerpt &&
          field.resourceExcerpt.value &&
          field.resourceExcerpt.value.length > 0
        "
      >
        <sc-rich-text v-if="field && field.resourceExcerpt" :field="field.resourceExcerpt" />
      </template>
      <template v-else>
        <sc-rich-text v-if="field && field.pageDescription" :field="field.pageDescription" />
      </template>
    </template>
  </div>
</template>

<script>
import { RichText } from '@sitecore-jss/sitecore-jss-vue';

export default {
  name: 'CIS-ResourceExcerpt',
  props: {
    field: {
      type: Object
    },
    maxCharacter: {
      type: Number,
      default: 0
    }
  },
  components: {
    ScRichText: RichText
  },
  computed: {
    excerpt() {
      var excerpt = '';

      if (this.field.resourceExcerpt.value.length > 0) excerpt = this.field.resourceExcerpt.value;
      else excerpt = this.field.pageDescription.value;

      // Remove HTML tags
      var excerptClean = excerpt.replace(/<[^>]+>/g, '').trim();

      return this.maxCharacter > 0 && excerpt.length > this.maxCharacter
        ? excerptClean.substr(0, this.maxCharacter) + '...'
        : excerptClean;
    }
  }
};
</script>
